function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Buss");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "desktop_Bus",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "assets_Bus",
  transform: "translate(-639.000000, -416.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "bus",
  transform: "translate(638.000000, 416.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  x: 0,
  y: 0,
  width: 17,
  height: 17
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.625,15.3 L5.375,15.3 L5.375,15.725 C5.375,16.429163 4.78737373,17 4.0625,17 C3.33762627,17 2.75,16.429163 2.75,15.725 L2.75,15.3 L1.875,15.3 C1.39175084,15.3 1,14.919442 1,14.45 L1,3.4 C1,1.52223185 2.56700338,3.44940413e-16 4.5,0 L11.5,0 C13.4329966,-3.44940413e-16 15,1.52223185 15,3.4 L15,14.45 C15,14.919442 14.6082491,15.3 14.125,15.3 L13.25,15.3 L13.25,15.725 C13.25,16.429163 12.6623737,17 11.9375,17 C11.2126263,17 10.625,16.429163 10.625,15.725 L10.625,15.3 Z M13.25,6.8 L13.25,3.4 C13.25,2.46111592 12.4664983,1.7 11.5,1.7 L4.5,1.7 C3.53350169,1.7 2.75,2.46111592 2.75,3.4 L2.75,6.8 L13.25,6.8 Z M13.25,8.5 L2.75,8.5 L2.75,13.6 L13.25,13.6 L13.25,8.5 Z M5.375,11.9 C4.89175084,11.9 4.5,11.519442 4.5,11.05 C4.5,10.580558 4.89175084,10.2 5.375,10.2 C5.85824916,10.2 6.25,10.580558 6.25,11.05 C6.25,11.519442 5.85824916,11.9 5.375,11.9 Z M10.625,11.9 C10.1417509,11.9 9.75,11.519442 9.75,11.05 C9.75,10.580558 10.1417509,10.2 10.625,10.2 C11.1082491,10.2 11.5,10.580558 11.5,11.05 C11.5,11.519442 11.1082491,11.9 10.625,11.9 Z",
  id: "Shape",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}))));

var SvgBus = function SvgBus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "17px",
    viewBox: "0 0 14 17",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bus.b552f2ba.svg";
export { ForwardRef as ReactComponent };